<div class="td-wb-modal-notification-footer">

  <div class="td-wb-modal-notification-footer__button-container"></div>

  @if (totalSubModals() > 1) {
    <div class="td-wb-modal-notification-footer__pagination">
      <td-wb-pagination [selectedPage]="step()"
                        [itemCount]="totalSubModals()"
                        [itemsPerPage]="1"
                        (selectedPageChange)="goToSelected($event)" />
    </div>
  }

  <div class="td-wb-modal-notification-footer__button-container">
    @if (step() + 1 === totalSubModals()) {
      <button id="td-wb-modal-notification-footer-done-button"
              class="td-wb-modal-notification-footer__button"
              tdWbButton
              tdWbModalClose>
        <span [translate]="buttonText()"></span>
      </button>
    }
  </div>
</div>
